import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnLprHotList extends SnModel {
  @Expose()
  public id: number;

  @Expose()
  public name: string;

  @Expose()
  public isPublic: boolean;

  @Expose()
  public type: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
